import styled from "styled-components";
import { TableCell } from "@mui/material";

export const Loading = styled.div`
  padding: 1rem 1.25rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
`;

export const Container = styled.div`
  padding: 1rem 1.25rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 0.25rem;
  align-items: center;
  padding: 0.5rem 0;
  margin-top: 24px;
`;

export const Cell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: "300px";
`;
